import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import InfoIcon from '@material-ui/icons/InfoOutlined';

import ContactDetails from '../ContactDetails/ContactDetails';
import BaseDialog from '../BaseDialog/BaseDialog';
import { getString } from '../../helpers/stringHelpers';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class ContactModal extends React.Component {
  render() {
    const { classes, open, handleClose } = this.props;

    return (
      <div className={classes.root}>
        <BaseDialog
          open={open}
          title={portalContent.CONTACT_MODAL_TITLE}
          content={
            <React.Fragment>
              <Typography className={classes.dialogText} gutterBottom>
                {portalContent.CONTACT_MODAL_CONTENT}
              </Typography>
              <ContactDetails />
            </React.Fragment>
          }
          contentWrap={false}
          buttonAction={handleClose}
          buttonLabel={getString('contactDetails', 'CLOSE_BUTTON_LABEL')}
          icon={InfoIcon}
        />
      </div>
    );
  }
}

ContactModal.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

ContactModal.defaultProps = {};

export default withStyles(styles)(ContactModal);
